import { MessageCircle } from "react-feather";
import { isTeacherLeader } from "../../../../utils/permissions";
import { hasEmailAccess } from "../../../../utils/emailAccessConfig";

/**
 * Teacher dashboard chat link from admin teacher profile.
 * Same handoff as View Dashboard — plain new-tab open to betadashboard /chat.
 *
 * REACT_APP_VIEW_CHAT_EMAIL_RESTRICTED:
 * - true  → only allowlisted emails can see View Chat
 * - false → visible to every admin
 *
 * Teacher Leaders never get View Chat (hidden), regardless of the flag.
 */

/** When true, View Chat is limited to EMAIL_ACCESS.viewChat. When false, open to all admins. */
export const isViewChatEmailRestricted = (): boolean => {
  const raw = String(process.env.REACT_APP_VIEW_CHAT_EMAIL_RESTRICTED ?? "true")
    .trim()
    .toLowerCase();
  return raw !== "false" && raw !== "0";
};

/** Whether View Chat should appear for the current admin (TL always excluded). */
export const isTeacherViewChatEnabled = (): boolean => {
  if (isTeacherLeader()) return false;
  if (!isViewChatEmailRestricted()) return true;
  return hasEmailAccess("viewChat");
};

export const getTeacherDashboardOrigin = (): string => {
  const override = (process.env.REACT_APP_TEACHER_DASHBOARD_ORIGIN || "").trim();
  if (override) return override.replace(/\/$/, "");

  const api = process.env.REACT_APP_WEBAPI_BASEURL || "";
  if (api.includes("beta.")) return "https://betadashboard.artiumacademy.com";
  if (api.includes("uat.")) return "https://uatdashboard.artiumacademy.com";
  return "https://betadashboard.artiumacademy.com";
};

/** Same pattern as View Dashboard home URL, but /chat path. */
export const buildTeacherChatUrl = (teacherId?: string | number | null): string => {
  const id = teacherId != null ? String(teacherId).trim() : "";
  return id
    ? `${getTeacherDashboardOrigin()}/chat?teacherId=${id}`
    : `${getTeacherDashboardOrigin()}/chat`;
};

/** Sidebar marker title — opens external chat instead of an in-app tab. */
export const VIEW_CHAT_TAB_TITLE = "View Chat";

export const viewChatSideButton = {
  className: "light",
  icon: <MessageCircle />,
  title: VIEW_CHAT_TAB_TITLE,
  external: true as const,
};
